"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.S3Storage = void 0;
const domain_1 = require("@home-health-notify/domain");
const http_1 = require("../http");
/* eslint-disable no-useless-catch */
class S3Storage {
    constructor(config, authStatusManager, httpAdapter) {
        this.config = config;
        this.authStatusManager = authStatusManager;
        this.httpAdapter = httpAdapter;
    }
    getFileUploadSignedUrl(file, key, isThumbnail) {
        return __awaiter(this, void 0, void 0, function* () {
            const filesToUpload = [
                {
                    fileName: key,
                    contentType: file.type,
                    contentLength: file.size,
                },
            ];
            const queryString = `filesToUpload=${encodeURIComponent(JSON.stringify(filesToUpload))}`;
            const mediaUrl = `${this.config.baseUrl}${http_1.urls.fetchPreSignedMedia}`;
            const thumbnailUrl = `${this.config.baseUrl}${http_1.urls.fetchPreSignedThumbnail}`;
            try {
                const response = yield this.httpAdapter.get(`${isThumbnail ? thumbnailUrl : mediaUrl}?${queryString}`);
                const [data] = response.data.data;
                const { endpointHint: url, url: signedUrl, headers } = data;
                return { url, signedUrl, headers };
            }
            catch (error) {
                if (error.name == "NotAuthorizedException") {
                    yield this.authStatusManager.logoutUser();
                    throw new domain_1.ForceLogoutException("Not authorized to generate signed url");
                }
                throw error;
            }
        });
    }
    uploadToSignedUrl(file, key, uploadHandler, onUploadProgress, onUploadSuccess, onUploadError, isThumbnail) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { url, signedUrl, headers } = yield this.getFileUploadSignedUrl(file, key, isThumbnail);
                const response = yield uploadHandler(signedUrl, key, file, headers, onUploadProgress);
                if (![200, 201].includes(response.status)) {
                    throw new Error(`Upload failed with status: ${response.status}, body: ${response.body}`);
                }
                onUploadSuccess === null || onUploadSuccess === void 0 ? void 0 : onUploadSuccess({ url });
            }
            catch (e) {
                if (onUploadError) {
                    onUploadError(file, e);
                }
                else {
                    throw e;
                }
            }
        });
    }
}
exports.S3Storage = S3Storage;
